import { ArticleView } from 'src/pages/article/types';
import { KBFilter, ModuleSearchRequest } from 'src/types';
import { nzApiAxios } from 'src/utils/nz-axios/nz-axios';

export const sectionsApiUrl = '/KnowledgeBase';
export const articlesApiUrl = '/Articles';

const ApiUrls = {
  sectionsApiUrl,
  articlesApiUrl
};

const GetSectionsRequest = (params: Partial<KBFilter>) =>
  nzApiAxios.get(sectionsApiUrl, { params }).then((value) => value?.data);

const GetSection = (slug: string) => nzApiAxios.get(sectionsApiUrl + `/${slug}`).then((value) => value?.data);

const GetModule = (params: ModuleSearchRequest) =>
  nzApiAxios.get(sectionsApiUrl + `/module`, { params }).then((value) => value?.data);

const GetMaterialBySlug = (slug: string): Promise<ArticleView> =>
  nzApiAxios.get(ApiUrls.articlesApiUrl + `/${slug}`).then((response) => response.data);

const API = {
  search: GetSectionsRequest,
  getSection: GetSection,
  getModule: GetModule,
  getMaterial: GetMaterialBySlug
};

export { ApiUrls };
export default API;
